import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Home, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { WHATSAPP_NUMBER } from "@/components/WhatsAppFloatingButton";
import { thankYouCopy } from "@/lib/thankYou";
import { trackRegistrationCompleted } from "@/lib/openaiPixel";

const ThankYou = () => {
  const [returnTo, setReturnTo] = useState("/");
  const { pathname } = useLocation();
  const copy = thankYouCopy(pathname);

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("tc_return_to");
      if (stored && stored.startsWith("/") && !stored.startsWith("/obrigado")) {
        setReturnTo(stored);
      }
    } catch {
      /* ignore */
    }
    // ChatGPT Ads conversion: any thank-you page load = completed registration
    trackRegistrationCompleted({ page_path: pathname });
  }, [pathname]);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Olá! Acabei de enviar uma solicitação pelo site e gostaria de mais informações."
  )}`;

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-2xl text-center">
          <div className="bg-card rounded-2xl border border-border shadow-xl p-10 md:p-14">
            <div className="flex justify-center mb-6">
              <div className="rounded-full bg-accent/10 p-4">
                <CheckCircle2 className="h-16 w-16 text-accent" strokeWidth={1.5} />
              </div>
            </div>
            <h1 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
              {copy.title}
            </h1>
            <p className="font-body text-lg text-muted-foreground mb-2">{copy.subtitle}</p>
            <p className="font-body text-muted-foreground mb-8">
              Nossa equipe entrará em contato em breve pelo e-mail ou telefone informado. Se preferir
              uma resposta imediata, você pode falar conosco pelo WhatsApp agora.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button variant="gold" size="lg" asChild>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  <Phone className="h-5 w-5" />
                  Falar no WhatsApp
                </a>
              </Button>
              <Button variant="outline" size="lg" asChild>
                <Link to={returnTo}>
                  <Home className="h-5 w-5" />
                  {copy.ctaLabel}
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ThankYou;
